export default class pesquisaSatisfacaoConstants {

    public static pesquisaSatisfacao = [
        "Nenhuma",
        "Classificação de atendimento",
        "Pesquisa externa"
    ];

    public static readonly nenhuma = "Nenhuma";

    public static readonly classificacaoAtendimento = "Classificação de atendimento";

    public static readonly pesquisaExterna = "Pesquisa externa";

    public static readonly pesquisaCustomizada = "Pesquisa customizada";
}